"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.DEFAULT_IMAGE = exports.FEATURE_NAME = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _EquizzerActions = _interopRequireDefault(require("../actions/EquizzerActions"));

var _ThemeActions = _interopRequireDefault(require("../../ThemeStore/ThemeActions2"));

var _RestService = _interopRequireDefault(require("../services/RestService"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _BuildConstants = require("../../../../utils/BuildConstants");

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var FEATURE_NAME = 'equeoqd';
exports.FEATURE_NAME = FEATURE_NAME;
var DEFAULT_IMAGE = 'data:image/jpeg;base64,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';
exports.DEFAULT_IMAGE = DEFAULT_IMAGE;
var UserService = {
  /*
   * get user
   * @returns the logged in user info
   */
  preload: function () {
    var _preload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(userId, userAuth) {
      var loadedUser;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              console.log('AAA preload', userAuth);
              _context.next = 4;
              return _RestService["default"].getUser([userId], userAuth);

            case 4:
              loadedUser = _context.sent;
              console.log('successfully got user, equizzer: ', loadedUser, loadedUser.id);
              return _context.abrupt("return", _promise["default"].resolve(loadedUser));

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              console.log('error loading user, equizzer', _context.t0);
              return _context.abrupt("return", _promise["default"].reject(new Error(_context.t0)));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    function preload(_x, _x2) {
      return _preload.apply(this, arguments);
    }

    return preload;
  }(),

  /*
   * get all group users
   * @returns list of group users
   */
  getAllUsersAndLoadTheme: function () {
    var _getAllUsersAndLoadTheme = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(groupId, userAuth) {
      var subjectId, groupObject, jsonTheme;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              subjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);
              _context2.next = 4;
              return _RestService["default"].getGroup([groupId], userAuth, subjectId);

            case 4:
              groupObject = _context2.sent;
              console.log('getAllUsersAndLoadTheme groupObject', groupObject);
              _context2.next = 8;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP, groupObject);

            case 8:
              if (!(groupObject && groupObject.value && groupObject.value.subjects && _config["default"].deleteDuplicateSubjectUsers)) {
                _context2.next = 14;
                break;
              }

              groupObject.value.subjects.forEach(function (subject) {
                if (subject.users) {
                  delete subject.users;
                }
              });
              _context2.next = 12;
              return _EquizzerActions["default"].setSubjects(groupObject.value.subjects);

            case 12:
              _context2.next = 17;
              break;

            case 14:
              if (!(groupObject && groupObject.value && groupObject.value.subjects)) {
                _context2.next = 17;
                break;
              }

              _context2.next = 17;
              return _EquizzerActions["default"].setSubjects(groupObject.value.subjects);

            case 17:
              /*
              console.log('successfully got group users', groupObject)
              const isActive = DataStore.getElementByPathImmediately(DATA_STORE_PATHS.QD_TOURNAMENT_IS_ACTIVE)
              console.log('isActive', isActive)
               if (!isActive) {
                if (groupObject.value && groupObject.value.hasTournaments) {
                  const userAuth = DataStore.getElementByPathImmediately(DATA_STORE_PATHS.QD_USER_AUTH)
                  if (userAuth && userAuth._auth && userAuth.id) {
                    const tournaments = await GameService.loadTournaments(userAuth._auth)
                    console.log('group has tournaments', tournaments)
                    const hasRunningTournament = QuizTournament.searchForRunningTournaments(tournaments, userAuth.id)
                    await DataStore.setSingleData(DATA_STORE_PATHS.QD_GROUP_ID, groupId, true)
                    await DataStore.setSingleData(DATA_STORE_PATHS.QD_GROUP_SUPPORTS_TOURNAMENTS, true, true)
                    if (hasRunningTournament) {
                      await DataStore.setSingleData(DATA_STORE_PATHS.QD_TOURNAMENT_IS_ACTIVE, true, false)
                      NavigationManager.goToTournamentStart(true)
                    }
                  }
                }
                else {
                  await DataStore.setSingleData(DATA_STORE_PATHS.QD_GROUP_ID, groupId, true)
                  await DataStore.setSingleData(DATA_STORE_PATHS.QD_GROUP_SUPPORTS_TOURNAMENTS, false, true)
                  await DataStore.setSingleData(DATA_STORE_PATHS.QD_TOURNAMENT_IS_ACTIVE, false, false)
                }
              }
              */
              console.log('groupObject: ', groupObject);

              if (groupObject.value.hasOwnProperty('minCorrectsForLearned')) {
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_MIN_CORRECTS_FOR_LEARNED, groupObject.value.minCorrectsForLearned);
              }

              if (groupObject.value.hasOwnProperty('selectionType')) {
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_QUESTION_SELECTION_TYPE, groupObject.value.selectionType);
              }

              if (groupObject.value.hasOwnProperty('winnerTakesAll')) {
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_WINNER_TAKES_IT_ALL, groupObject.value.winnerTakesAll, false);
              } else {
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_WINNER_TAKES_IT_ALL, false, false);
              }

              if (groupObject.value.hasOwnProperty('teamPoints')) {
                console.log('settingTeamPoints', groupObject.value.teamPoints);

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_TEAM_POINTS, groupObject.value.teamPoints, false);
              }

              if (groupObject.value.hasOwnProperty('hideFeedback')) {
                console.log('settingHideFeedback');

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK, groupObject.value.hideFeedback, false);
              } else {
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK, false, false);
              }

              if (groupObject.value.theme.length > 0) {
                console.log('theme vorhanden');
                jsonTheme = JSON.parse(groupObject.value.theme);

                _ThemeActions["default"].addTheme(jsonTheme, _BuildConstants.IS_KESI_APP, _BuildConstants.IS_KESI_APP);

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_THEME, jsonTheme, false);
              }

              if (groupObject.value.hasOwnProperty('showPresence')) {
                _EquizzerActions["default"].setShowPresences(Boolean(groupObject.value.showPresence));
              }

              _EquizzerActions["default"].setLeagueName(groupObject.value.liga);

              return _context2.abrupt("return", _promise["default"].resolve(groupObject.value.users));

            case 29:
              _context2.prev = 29;
              _context2.t0 = _context2["catch"](0);
              console.error('error loading group users', _context2.t0);
              return _context2.abrupt("return", _promise["default"].reject(_context2.t0));

            case 33:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 29]]);
    }));

    function getAllUsersAndLoadTheme(_x3, _x4) {
      return _getAllUsersAndLoadTheme.apply(this, arguments);
    }

    return getAllUsersAndLoadTheme;
  }(),
  setValuesForGroupObject: function () {
    var _setValuesForGroupObject = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(groupObject) {
      var subjectToSave, jsonTheme;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(groupObject && groupObject.value && groupObject.value.subjects)) {
                _context3.next = 5;
                break;
              }

              subjectToSave = JSON.parse((0, _stringify["default"])(groupObject.value.subjects));

              if (subjectToSave.users) {
                delete subjectToSave.users;
              }

              _context3.next = 5;
              return _EquizzerActions["default"].setSubjects(groupObject.value.subjects);

            case 5:
              if (groupObject.value.hasOwnProperty('minCorrectsForLearned')) {
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_MIN_CORRECTS_FOR_LEARNED, groupObject.value.minCorrectsForLearned);
              }

              if (groupObject.value.hasOwnProperty('selectionType')) {
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_QUESTION_SELECTION_TYPE, groupObject.value.selectionType);
              }

              if (groupObject.value.hasOwnProperty('winnerTakesAll')) {
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_WINNER_TAKES_IT_ALL, groupObject.value.winnerTakesAll, false);
              } else {
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_WINNER_TAKES_IT_ALL, false, false);
              }

              if (groupObject.value.hasOwnProperty('teamPoints')) {
                console.log('settingTeamPoints', groupObject.value.teamPoints);

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_TEAM_POINTS, groupObject.value.teamPoints, false);
              }

              if (groupObject.value.hasOwnProperty('hideFeedback')) {
                console.log('settingHideFeedback');

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK, groupObject.value.hideFeedback, false);
              } else {
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK, false, false);
              }

              if (groupObject.value.theme.length > 0) {
                console.log('theme vorhanden');
                jsonTheme = JSON.parse(groupObject.value.theme);

                _ThemeActions["default"].addTheme(jsonTheme, _BuildConstants.IS_KESI_APP, _BuildConstants.IS_KESI_APP);

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_THEME, jsonTheme, false);
              }

              if (groupObject.value.hasOwnProperty('showPresence')) {
                _EquizzerActions["default"].setShowPresences(Boolean(groupObject.value.showPresence));
              }

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function setValuesForGroupObject(_x5) {
      return _setValuesForGroupObject.apply(this, arguments);
    }

    return setValuesForGroupObject;
  }(),

  /*
   * get league seasons
   * @returns seasons
   */
  loadLeagueSeasons: function () {
    var _loadLeagueSeasons = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(groupId, userAuth) {
      var seasons;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _RestService["default"].getLeagueSeasons([groupId], userAuth);

            case 3:
              seasons = _context4.sent;
              console.log('successfully got league seasons', seasons);

              _EquizzerActions["default"].setSeasons(seasons);

              return _context4.abrupt("return", _promise["default"].resolve(seasons.value));

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              console.log('error loading league seasons', _context4.t0);
              return _context4.abrupt("return", _promise["default"].reject(_context4.t0));

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9]]);
    }));

    function loadLeagueSeasons(_x6, _x7) {
      return _loadLeagueSeasons.apply(this, arguments);
    }

    return loadLeagueSeasons;
  }(),

  /*
   * get all group users
   * @return learning state
   */
  loadLearningStates: function () {
    var _loadLearningStates = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(userAuth) {
      var shouldReturnValue,
          postQueue,
          postQueueHasStoreRound,
          storeElem,
          learningStateArr,
          learningStateToUse,
          subjectId,
          subjectLearningState,
          learningStateByCategory,
          _args5 = arguments;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              shouldReturnValue = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : false;
              _context5.prev = 1;
              _context5.next = 4;
              return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.QD_POST_QUEUE);

            case 4:
              _context5.t0 = _context5.sent;

              if (_context5.t0) {
                _context5.next = 7;
                break;
              }

              _context5.t0 = [];

            case 7:
              postQueue = _context5.t0;
              postQueueHasStoreRound = false;
              console.log('loadLearningState', postQueue);

              if (postQueue && postQueue.length > 0) {
                storeElem = postQueue.find(function (elem) {
                  return elem.request.url.indexOf('storeAnswer') !== -1 || elem.request.url.indexOf('storeRound') !== -1;
                });
                console.log('loadLearningState', storeElem);

                if (storeElem) {
                  postQueueHasStoreRound = true;
                }
              }

              if (!postQueueHasStoreRound) {
                _context5.next = 13;
                break;
              }

              return _context5.abrupt("return");

            case 13:
              _context5.next = 15;
              return _RestService["default"].getUserLearningState(userAuth);

            case 15:
              learningStateArr = _context5.sent;

              if (learningStateArr.length > 0 && learningStateArr[0].rubrics) {
                subjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);
                subjectLearningState = learningStateArr.find(function (learningState) {
                  return learningState.subjectId === subjectId;
                });

                if (subjectLearningState) {
                  learningStateToUse = subjectLearningState.rubrics;
                }
              } else {
                learningStateToUse = learningStateArr;
              }

              learningStateByCategory = {};

              if (learningStateToUse) {
                learningStateToUse.forEach(function (state) {
                  learningStateByCategory[state.name] = state;
                });
              }

              if (shouldReturnValue) {
                _context5.next = 23;
                break;
              }

              _context5.next = 22;
              return _EquizzerActions["default"].setLearningState(learningStateByCategory);

            case 22:
              return _context5.abrupt("return", _promise["default"].resolve());

            case 23:
              return _context5.abrupt("return", _promise["default"].resolve(learningStateByCategory));

            case 26:
              _context5.prev = 26;
              _context5.t1 = _context5["catch"](1);
              console.warn('error loading learning state (but we can go on anyway)', _context5.t1);
              return _context5.abrupt("return", _promise["default"].resolve());

            case 30:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 26]]);
    }));

    function loadLearningStates(_x8) {
      return _loadLearningStates.apply(this, arguments);
    }

    return loadLearningStates;
  }(),

  /*
   * update opponent list on starting game with a opponent
   * (Provided existing opponents list, selected opponent and game id)
   * @returns updated opponent list
   */
  updateOpponentsList: function updateOpponentsList(opponents, selectedOpponentId, gameId) {
    var updatedOpponentsList = [];
    opponents.forEach(function (opponent) {
      var opponentToAdd = opponent;

      if (opponent.id === selectedOpponentId) {
        // set game object
        opponentToAdd.game = gameId;
      }

      updatedOpponentsList.push(opponentToAdd);
    });
    return updatedOpponentsList;
  },
  mapOpponentsInfoToId: function mapOpponentsInfoToId() {
    var opponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var mappedOpponentsList = {};
    opponents.forEach(function (opponent) {
      mappedOpponentsList[opponent.id] = opponent;
    }); // console.log('UserService, mapOpponentsInfoToId', mappedOpponentsList)

    return mappedOpponentsList;
  },
  getPlayerState: function getPlayerState(userData, selectedOpponentData, currentGame) {
    console.log('UserService, initRound [user, game]', userData, currentGame);
    var updatedUserData = userData;
    var updatedSelectedOpponentData = selectedOpponentData;

    if (userData.id === currentGame.challenger) {
      updatedUserData.playerState = 'challenger';
      updatedSelectedOpponentData.playerState = 'opponent';
    } else {
      updatedUserData.playerState = 'opponent';
      updatedSelectedOpponentData.playerState = 'challenger';
    }

    return {
      userData: updatedUserData,
      selectedOpponentData: updatedSelectedOpponentData
    };
  },
  getUserImages: function () {
    var _getUserImages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(newUsers) {
      var currentUsers,
          userAuth,
          storedImages,
          usersWithExistingImage,
          usersWithNewImage,
          usersWithNoImage,
          userMd5s,
          userIds,
          promises,
          values,
          users,
          _args6 = arguments;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              currentUsers = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : [];
              userAuth = _args6.length > 2 ? _args6[2] : undefined;
              storedImages = _args6.length > 3 ? _args6[3] : undefined;
              usersWithExistingImage = [];
              usersWithNewImage = [];
              usersWithNoImage = [];

              if (newUsers) {
                _context6.next = 8;
                break;
              }

              return _context6.abrupt("return", _promise["default"].resolve());

            case 8:
              newUsers.forEach(function (newUser) {
                if (currentUsers.length > 0) {
                  var oldUsers = currentUsers.filter(function (oldUser) {
                    return oldUser.id === newUser.id;
                  });

                  if (oldUsers.length > 0) {
                    var oldUserObj = oldUsers[0];

                    if (newUser.pictureMd5) {
                      if (newUser.pictureMd5 !== oldUserObj.pictureMd5) {
                        // console.log(`${newUser.nickname} hat ein neues Bild - ${newUser.pictureMd5} & ${oldUserObj}`)
                        usersWithNewImage.push(newUser);
                      } else {
                        // console.log(`${newUser.nickname} hat ein altes Bild - ${newUser.pictureMd5}`)
                        newUser.picture = oldUserObj.picture;
                        usersWithExistingImage.push(newUser);
                      }
                    } else {
                      // console.log(`${newUser.nickname} hat kein Bild - ${newUser.pictureMd5}`)
                      newUser.picture = oldUserObj.picture;
                      usersWithNoImage.push(newUser);
                    }
                  } else {
                    if (newUser.pictureMd5) {
                      // console.log(`${newUser.nickname} ist neu und hat kein Bild`)
                      usersWithNewImage.push(newUser);
                    } else {
                      // console.log(`${newUser.nickname} ist neu und hat kein Bild`)
                      // newUser.picture = DEFAULT_IMAGE
                      usersWithNoImage.push(newUser);
                    }
                  }
                } else {
                  if (storedImages && (0, _keys["default"])(storedImages).length > 0) {
                    var key = (0, _keys["default"])(storedImages).filter(function (key) {
                      return key === newUser.pictureMd5;
                    })[0];
                    var img = storedImages[key];

                    if (img) {
                      // console.log(`${newUser.nickname} hat ein Bild im storage - ${newUser.pictureMd5}`)
                      newUser.picture = img;
                      usersWithExistingImage.push(newUser);
                    } else if (newUser.pictureMd5) {
                      // console.log(`${newUser.nickname} hat kein Bild im storage, muss neu geladen werden - ${newUser.pictureMd5}`)
                      usersWithNewImage.push(newUser);
                    } else {
                      // console.log(`${newUser.nickname} hat kein Bild im storage und auch keins hochgeladen, nimm das default`)
                      // newUser.picture = DEFAULT_IMAGE
                      usersWithNoImage.push(newUser);
                    }
                  } else {
                    if (newUser.pictureMd5) {
                      // console.log(`${newUser.nickname} muss neu geladen werden - ${newUser.pictureMd5}`)
                      usersWithNewImage.push(newUser);
                    } else {
                      // console.log(`${newUser.nickname} hat kein Bild hochgeladen, nimm das default`)
                      // newUser.picture = DEFAULT_IMAGE
                      usersWithNoImage.push(newUser);
                    }
                  }
                }
              });

              if (storedImages) {
                userMd5s = newUsers.map(function (user) {
                  return user.pictureMd5;
                });
                (0, _keys["default"])(storedImages).forEach(function (key) {
                  if (!userMd5s.includes(key)) {
                    console.log("Bild mit md5 ".concat(key, " ist gespeichert, wird aber nicht mehr verwendet -> bild l\xF6schen"));

                    _DataStore["default"].removeData("".concat(_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH, ".").concat(key));
                  }
                });
              }

              if (usersWithNewImage.length > 0) {
                console.log("Es m\xFCssen ".concat(usersWithNewImage.length, " Bilder neu geladen werden"));
              }

              userIds = usersWithNewImage.map(function (user) {
                return user.id;
              });
              promises = userIds.map(function (id) {
                return _RestService["default"].getPlayerImage([id], userAuth);
              });
              _context6.prev = 13;
              _context6.next = 16;
              return _promise["default"].all(promises);

            case 16:
              values = _context6.sent;
              values.forEach(function (user, index) {
                console.log('getAllUsersWithImages', user);
                usersWithNewImage[index].picture = user.picture;

                _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH, ".").concat(user.pictureMd5), user.picture);
              });
              users = usersWithExistingImage.concat(usersWithNewImage).concat(usersWithNoImage);
              return _context6.abrupt("return", _promise["default"].resolve(users));

            case 22:
              _context6.prev = 22;
              _context6.t0 = _context6["catch"](13);
              console.log(_context6.t0);
              return _context6.abrupt("return", _promise["default"].reject(_context6.t0));

            case 26:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[13, 22]]);
    }));

    function getUserImages(_x9) {
      return _getUserImages.apply(this, arguments);
    }

    return getUserImages;
  }(),
  getSingleUserImage: function () {
    var _getSingleUserImage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(userId, userAuth) {
      var user;
      return _regenerator["default"].wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return _RestService["default"].getPlayerImage([userId], userAuth);

            case 3:
              user = _context7.sent;

              _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH, ".").concat(user.pictureMd5), user.picture);

              return _context7.abrupt("return", _promise["default"].resolve(user));

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              console.log(_context7.t0);
              return _context7.abrupt("return", _promise["default"].reject(_context7.t0));

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 8]]);
    }));

    function getSingleUserImage(_x10, _x11) {
      return _getSingleUserImage.apply(this, arguments);
    }

    return getSingleUserImage;
  }(),
  saveCurrentUserProfilePicture: function () {
    var _saveCurrentUserProfilePicture = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(currentUserId, profilePic, userAuth) {
      var userInfo, response;
      return _regenerator["default"].wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return _RestService["default"].getUser([currentUserId], userAuth);

            case 3:
              userInfo = _context8.sent;
              userInfo.picture = profilePic;
              _context8.next = 7;
              return _RestService["default"].postPlayerImage([currentUserId], userInfo, userAuth);

            case 7:
              response = _context8.sent;
              console.log('updated profile pic', response);
              return _context8.abrupt("return", _promise["default"].resolve(response));

            case 12:
              _context8.prev = 12;
              _context8.t0 = _context8["catch"](0);
              console.error("could not update profile pic: ".concat(_context8.t0));
              return _context8.abrupt("return", _promise["default"].reject(_context8.t0));

            case 16:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[0, 12]]);
    }));

    function saveCurrentUserProfilePicture(_x12, _x13, _x14) {
      return _saveCurrentUserProfilePicture.apply(this, arguments);
    }

    return saveCurrentUserProfilePicture;
  }(),
  getUserProfilePicture: function () {
    var _getUserProfilePicture = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(userId, userAuth) {
      var userInfo, picture;
      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return _RestService["default"].getPlayerImage([userId], userAuth);

            case 3:
              userInfo = _context9.sent;
              picture = DEFAULT_IMAGE;

              if (userInfo && userInfo.picture) {
                picture = userInfo.picture;
              }

              userInfo.picture = picture;
              return _context9.abrupt("return", _promise["default"].resolve(userInfo));

            case 10:
              _context9.prev = 10;
              _context9.t0 = _context9["catch"](0);
              console.error('error fetching user profile pictures');
              return _context9.abrupt("return", _promise["default"].reject(_context9.t0));

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[0, 10]]);
    }));

    function getUserProfilePicture(_x15, _x16) {
      return _getUserProfilePicture.apply(this, arguments);
    }

    return getUserProfilePicture;
  }()
};
var _default = UserService;
exports["default"] = _default;